<script lang="ts" setup>
interface Props {
	size?: string;
}

defineProps<Props>();
</script>
<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		:width="size ?? '24'"
		:height="size ?? '24'"
		fill="none"
	>
		<g clip-path="url(#clip0_2040_151617)">
			<path
				d="M24.666 12.0002C24.666 5.37282 19.2934 0.000244141 12.666 0.000244141C6.03859 0.000244141 0.666016 5.37282 0.666016 12.0002C0.666016 17.9897 5.05422 22.9542 10.791 23.8545V15.469H7.74414V12.0002H10.791V9.35649C10.791 6.34899 12.5826 4.68774 15.3236 4.68774C16.6361 4.68774 18.0098 4.92212 18.0098 4.92212V7.87524H16.4966C15.006 7.87524 14.541 8.80032 14.541 9.75024V12.0002H17.8691L17.3371 15.469H14.541V23.8545C20.2778 22.9542 24.666 17.9897 24.666 12.0002Z"
				fill="#1877F2"
			/>
			<path
				d="M17.3371 15.469L17.8691 12.0002H14.541V9.75024C14.541 8.80126 15.006 7.87524 16.4966 7.87524H18.0098V4.92212C18.0098 4.92212 16.6366 4.68774 15.3236 4.68774C12.5826 4.68774 10.791 6.34899 10.791 9.35649V12.0002H7.74414V15.469H10.791V23.8545C12.0335 24.0488 13.2986 24.0488 14.541 23.8545V15.469H17.3371Z"
				fill="white"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2040_151617">
				<rect
					:width="size ?? '24'"
					:height="size ?? '24'"
					fill="white"
					transform="translate(0.666016 0.000244141)"
				/>
			</clipPath>
		</defs>
	</svg>
</template>
